<template>
  <div class="block">
    <div class="logo">
      <img
        :src="
          mPageMedias.get(category.mediaIcon).urlCompressed ||
          mPageMedias.get(category.mediaIcon).url
        "
      />
    </div>
    <div class="content">
      <h3 class="title">{{ category.title }}</h3>
      <p class="description">{{ category.description }}</p>
    </div>
    <ButtonBase
      theme="secondary"
      stroke="n"
      class="button"
      :disabled="false"
      rounded
      size="small"
      :to="routeLink.path"
      @click.capture="handleClickPath"
    >
      Réviser
    </ButtonBase>
  </div>
</template>
<script setup lang="ts">
interface Props {
  category: CategorySchema;
}

const props = defineProps({
  category: null
});

const { mPageMedias } = inject(INJECT_CATEGORY_PAGE);

const { handleClickPath, routeLink } = await useCategoryLinkTryAndLock(
  props.category
);
</script>
<style lang="scss" scoped>
.block {
  display: grid;
  grid-template-columns: 5rem auto auto;
  align-items: center;
  padding: var(--gap_m);
  border-color: var(--color_secondary_lighter);
  background-color: var(--color_neutral_25);
  gap: var(--gap_m);

  @include stroke('m', 'm');
}

.title {
  @include font('m', 700, 'secondary');
}

.content {
  --padding_horizontal: var(--gap_m);

  padding: 0;
}
</style>
